/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator';
import { VALID_UUID_REGEX } from '@/util/constants/constants';

// Plain Latin letters, a curated set of Dutch/French accented letters, digits, common
// punctuation, the Euro sign and whitespace. Mirrors the backend's AllowedCharactersValidator
// (nr-api, EPDB-1399) so the user gets the same restriction as an inline error, not a round-trip.
const ALLOWED_CHARACTERS_REGEX = /^[A-Za-zÀÂÄÇÉÈÊËÎÏÑÔÖŒÙÛÜŸàâäçéèêëîïñôöœùûüÿ0-9 .,'"()/:;&+%€\t\n\r-]*$/;

@Component
export default class RulesMixin extends Vue {
  get $rule() {
    return {
      required: (v: any) => !!v || this.$t('errors.verplicht'),
      requiredBoolean: (v: boolean) =>
        v !== undefined || this.$t('errors.verplicht'),
      arrayRequired: (v: any) =>
        v?.length > 0 || this.$t('errors.minstens-een'),
      positive: (v: any) => !v || Number(v) >= 0 || this.$t('errors.positief'),
      inclusiveMax: (max: number) => {
        return (v: any) =>
          !v ||
          max == null ||
          Number(v) <= max ||
          this.$t('errors.inclusive-max', { max: max });
      },
      max: (max: number) => {
        return (v: any) =>
          !v ||
          max == null ||
          Number(v) < max ||
          this.$t('errors.max', { max: max });
      },
      inclusiveMin: (min: number) => {
        return (v: any) =>
          !v ||
          min == null ||
          Number(v) >= min ||
          this.$t('errors.inclusive-min', { min: min });
      },
      min: (min: number) => {
        return (v: any) =>
          !v ||
          min == null ||
          Number(v) > min ||
          this.$t('errors.min', { min: min });
      },
      precision: (precision: number) => {
        return (v: any) =>
          !v ||
          !v.split('.')[1] ||
          v.split('.')[1]?.length <= precision ||
          (precision === 0
            ? this.$t('errors.integer')
            : this.$tc('errors.precision', precision));
      },
      maxLength: (max: number) => {
        return (v: string) =>
          !v ||
          max == null ||
          v.length <= max ||
          this.$t('errors.max-length', { max: max });
      },
      minLength: (min: number) => {
        return (v: string) =>
          !v ||
          min == null ||
          v.trim().length >= min ||
          this.$t('errors.min-length', { min: min });
      },
      eanCode: (v: any) =>
        (v.length === 18 && v.substr(0, 2) === '54' && /^\d+$/.test(v)) ||
        this.$t('errors.ean-code'),
      uuidRule: (customError?: string) => (v: string): boolean | string =>
        !v || VALID_UUID_REGEX.test(v) || (customError || (this.$t('errors.ongeldig-uuid') as string)),
      allowedCharacters: (v: string) =>
        !v || ALLOWED_CHARACTERS_REGEX.test(v) || this.$t('errors.niet-toegelaten-karakters')
    };
  }
}
